"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _checked = _interopRequireDefault(require("../../../assets/images/checkBox/checked.svg"));

var _checkverde = _interopRequireDefault(require("../../../assets/images/checkBox/checkverde.svg"));

var _checkrosa = _interopRequireDefault(require("../../../assets/images/checkBox/checkrosa.svg"));

var _unchecked = _interopRequireDefault(require("../../../assets/images/checkBox/unchecked.svg"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  input {\n    display: none;\n    &:checked + label {\n      &:before {\n        background-color: ", ";\n        background-image: ", "\n      } \n    }\n  }\n\n  label {\n    position: relative;\n    min-height: 16px;\n    min-width: 16px;\n    display: inline-block;\n\n    p {\n      display: inline;\n      color: ", ";\n      font-family: ", ";\n      font-weight: 500;\n      font-size: 13px;\n      line-height: 21px;\n      margin-left: 20px;\n\n      &.filter-text {\n        color: ", ";\n        font-size: 18px;\n        line-height: 24px;\n        margin-left: 23px;\n      }\n    }\n\n    &:before {\n      content: \"\";\n      width: 16px;\n      height: 16px;\n      position: absolute;\n      display: inline-block;\n      top: 50%;\n      transform: translateY(-50%);\n      background-image: url(", ");\n      z-index: 5;\n      cursor: pointer;\n    }\n  }\n"])), _variables.GlobalColors.white, function (_ref) {
  var typeColor = _ref.typeColor;
  return typeColor === "purple" ? "url(".concat(_checked.default, ")") : typeColor === "green" ? "url(".concat(_checkverde.default, ")") : "url(".concat(_checkrosa.default, ")");
}, _variables.GlobalColors.s4, _variables.FontFamily.AvenirNext, _variables.GlobalColors.magenta_s2, _unchecked.default);

exports.Container = Container;